export const SET_PRODUCT = "SET_PRODUCT";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PRICE_PLANS = "SET_PRICE_PLANS";
export const SET_PRICES = "SET_PRICES";
